__webpack_require__.p = "https://js-static.iimjobs.com/production/16.0.2/_next/";